import { type ElementType } from 'react'
import { cn } from '@/lib/cn'

export interface HoverTextProps {
  /** The text to animate. */
  text: string
  /** Tag to render the wrapper as. Defaults to a span. */
  as?: ElementType
  className?: string
}

/**
 * Bold-template "btn-animate-y" hover effect: the label slides up and is
 * replaced by an identical copy rising from below. Trigger it by placing
 * this inside an element that carries the Tailwind `group` class
 * (e.g. a nav link or button); the slide fires on `group-hover`.
 */
export const HoverText = ({ text, as = 'span', className }: HoverTextProps) => {
  const Tag = as

  return (
    <Tag className={cn('hover-text', className)}>
      <span className="hover-text__inner">
        <span className="hover-text__copy">{text}</span>
        <span className="hover-text__copy hover-text__copy--clone" aria-hidden="true">
          {text}
        </span>
      </span>
    </Tag>
  )
}
